import { render } from "./NewsCarousal.vue?vue&type=template&id=6bdbeeae&scoped=true"
import script from "./NewsCarousal.vue?vue&type=script&lang=js"
export * from "./NewsCarousal.vue?vue&type=script&lang=js"

import "./NewsCarousal.vue?vue&type=style&index=0&id=6bdbeeae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bdbeeae"]])

export default __exports__